const cards = [
  {
    title: '暗香',
    author: '墨染青衣',
    genre: '古风权谋',
    desc: '权倾朝野的摄政王与身世成谜的少年刺客，在暗流涌动的朝堂与江湖之间，一段跨越身份与宿命的深情悄然绽放。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20danmei%20manga%20cover%20art%20style%20two%20beautiful%20anime%20male%20characters%20in%20ancient%20Chinese%20hanfu%20robes%20one%20in%20dark%20official%20robe%20one%20in%20black%20assassin%20attire%20standing%20back%20to%20back%20in%20moonlight%20ancient%20palace%20background%20warm%20atmospheric%20lighting%20delicate%20illustration&width=600&height=800&seq=card-manga-01&orientation=portrait',
    tag: '热门连载',
  },
  {
    title: '夜行',
    author: '寒川',
    genre: '悬疑探案',
    desc: '刑警队长与神秘法医联手侦破连环案件，在追凶过程中揭开彼此隐藏多年的秘密。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20manga%20cover%20art%20modern%20detective%20theme%20two%20handsome%20anime%20male%20characters%20in%20dark%20coats%20standing%20in%20rainy%20urban%20alley%20at%20night%20neon%20lights%20reflecting%20on%20wet%20pavement%20mysterious%20atmosphere%20cinematic%20composition%20detailed%20anime%20illustration&width=600&height=800&seq=card-manga-02&orientation=portrait',
    tag: '新作推荐',
  },
  {
    title: '青涩',
    author: '林深时见',
    genre: '校园青春',
    desc: '阳光开朗的篮球少年与安静内敛的图书馆管理员，在青春校园里写下最纯粹的初恋故事。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20manga%20cover%20art%20school%20romance%20theme%20two%20anime%20male%20teenagers%20in%20school%20uniforms%20under%20cherry%20blossom%20tree%20sunlight%20filtering%20through%20leaves%20gentle%20atmosphere%20pastel%20colors%20soft%20anime%20illustration%20style%20clean%20composition&width=600&height=800&seq=card-manga-03&orientation=portrait',
    tag: '高甜必看',
  },
  {
    title: '星河',
    author: '远舟',
    genre: '科幻星际',
    desc: '星际舰队指挥官在浩瀚宇宙中邂逅神秘外星旅者，跨越文明与物种的禁忌之恋震撼启航。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20manga%20cover%20art%20sci-fi%20theme%20two%20male%20anime%20characters%20in%20futuristic%20military%20uniforms%20standing%20before%20a%20spacecraft%20window%20showing%20distant%20galaxy%20stars%20and%20nebula%20cool%20blue%20and%20silver%20tones%20detailed%20futuristic%20design%20atmospheric%20anime%20illustration&width=600&height=800&seq=card-manga-04&orientation=portrait',
    tag: '连载中',
  },
  {
    title: '逆光',
    author: '温酒',
    genre: '都市情感',
    desc: '广告公司创意总监与自由摄影师在都市霓虹中相遇相知，在职场与生活交织中守护彼此。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20manga%20cover%20art%20urban%20romance%20theme%20two%20stylish%20anime%20male%20characters%20in%20modern%20fashionable%20clothing%20holding%20coffee%20on%20city%20rooftop%20at%20sunset%20warm%20golden%20light%20city%20skyline%20background%20emotional%20atmosphere%20clean%20illustration%20style&width=600&height=800&seq=card-manga-05&orientation=portrait',
    tag: '人气作品',
  },
  {
    title: '浮生',
    author: '云中鹤',
    genre: '仙侠玄幻',
    desc: '千年剑仙与凡间少年缘起一面，三生三世轮回中追寻不变的真心，仙魔大战震撼上演。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20manga%20cover%20art%20xianxia%20fantasy%20theme%20two%20anime%20male%20characters%20in%20flowing%20immortal%20robes%20floating%20amidst%20clouds%20and%20ancient%20mountains%20sword%20in%20hand%20celestial%20palace%20in%20distance%20mystical%20golden%20and%20pearl%20lighting%20grand%20scale%20detailed%20illustration&width=600&height=800&seq=card-manga-06&orientation=portrait',
    tag: '经典必读',
  },
  {
    title: '暖冬',
    author: '南风知意',
    genre: '治愈温情',
    desc: '失忆青年在偏远小镇遇到温柔的咖啡店老板，一场意外让两人重新找到生命中的光。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20manga%20cover%20art%20healing%20slice%20of%20life%20theme%20two%20anime%20male%20characters%20in%20cozy%20sweaters%20sitting%20in%20a%20warm%20cafe%20with%20steaming%20coffee%20winter%20snow%20outside%20window%20soft%20warm%20lighting%20gentle%20atmosphere%20cozy%20illustration%20style&width=600&height=800&seq=card-manga-07&orientation=portrait',
    tag: '新作上架',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500">编辑精选的优质免费耽美漫画作品</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card, idx) => (
            <a key={idx} href="#cards" className="group block">
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-secondary-200">
                <img
                  src={card.image}
                  alt={`耽美漫画《${card.title}》- ${card.genre}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 bg-primary-500 text-background-50 text-[10px] rounded-full font-medium">
                    {card.tag}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-0.5">
                《{card.title}》
              </h3>
              <p className="text-xs text-foreground-500 mb-1">
                {card.author} · {card.genre}
              </p>
              <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">{card.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}